import {
  AfterViewInit,
  Component,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  Input,
  inject,
} from '@angular/core';

import { ActualLegendItemBadgeShape, IgxCategoryXAxisComponent } from 'igniteui-angular-charts';
import { IgxCategoryYAxisComponent } from 'igniteui-angular-charts';
import { IgxDataChartComponent } from 'igniteui-angular-charts';
import { IgxNumericXAxisComponent } from 'igniteui-angular-charts';
import { IgxNumericYAxisComponent } from 'igniteui-angular-charts';
import { IgxStacked100AreaSeriesComponent } from 'igniteui-angular-charts';
import { IgxStacked100BarSeriesComponent } from 'igniteui-angular-charts';
import { IgxStacked100ColumnSeriesComponent } from 'igniteui-angular-charts';
import { IgxStacked100LineSeriesComponent } from 'igniteui-angular-charts';
import { IgxStacked100SplineSeriesComponent } from 'igniteui-angular-charts';
import { IgxStackedAreaSeriesComponent } from 'igniteui-angular-charts';
import { IgxStackedBarSeriesComponent } from 'igniteui-angular-charts';
import { IgxStackedColumnSeriesComponent } from 'igniteui-angular-charts';
import { IgxStackedFragmentSeriesComponent } from 'igniteui-angular-charts';
import { IgxStackedLineSeriesComponent } from 'igniteui-angular-charts';
import { IgxStackedSplineSeriesComponent } from 'igniteui-angular-charts';
import { Observable, Subscription, interval } from 'rxjs';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { CompanyAddNewComponent } from 'src/app/profiles/companies/company-add-new/company-add-new.component';
import { IReceivableChartData, IReportInvoiceAging } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-invoice-aging-chart',
  templateUrl: './invoice-aging-chart.component.html',
  styleUrl: './invoice-aging-chart.component.scss',
})
export class InvoiceAgingChartComponent implements OnInit {
  private timer;
  private chartTimer;
  public data: IReceivableChartData[];
  public dataAmount: IReceivableChartData[];
  public chartData: IReceivableChartData[];

  public catXAxis: IgxCategoryXAxisComponent;
  public numYAxis: IgxNumericYAxisComponent;

  public catYAxis: IgxCategoryYAxisComponent;
  public numXAxis: IgxNumericXAxisComponent;

  @ViewChild('chart', { static: true })
  public chart: IgxDataChartComponent;

  _appGeneralState = inject(AppGeneralStateService);

  constructor() {
    this.catXAxis = new IgxCategoryXAxisComponent();
    this.catXAxis.label = 'segment';

    this.catYAxis = new IgxCategoryYAxisComponent();
    this.catYAxis.label = 'segment';

    this.numXAxis = new IgxNumericXAxisComponent();
    this.numYAxis = new IgxNumericYAxisComponent();
  }

  public ngOnInit() {
    this._appGeneralState.invoiceAgingDataSubject.subscribe({
      next: (data) => {
        this.data = [];
        this.initData(data);
      },
    });
  }

  public initData(reportData: IReportInvoiceAging[]) {
    if (reportData != undefined) {
      this.initReceivablQuantityData(reportData);
      this.initReceivableAmountData(reportData);

      this.chartTimer = interval(600).subscribe((x) => {
        if (this.data.length > 0) {
          this.chartData = this.data;
          this.setSeries();
          this.chartTimer.unsubscribe();
        }
      });
    }
  }

  public initReceivableAmountData(reportData: IReportInvoiceAging[]): void {
    let dataPoint: IReceivableChartData = {} as IReceivableChartData;

    this.dataAmount = [];

    //Get Current Data (0)
    dataPoint.segment = 'Current';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '0' && data.parkerPayType == 'P').amount;
    dataPoint.company = reportData.find((data) => data.agingCategory == '0' && data.parkerPayType == 'C').amount;

    this.dataAmount.push(dataPoint);

    //Get Data  1 - 30 (1)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = '1-30';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '1' && data.parkerPayType == 'P').amount;
    dataPoint.company = reportData.find((data) => data.agingCategory == '1' && data.parkerPayType == 'C').amount;

    this.dataAmount.push(dataPoint);

    //Get Data  31 - 60 (2)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = '31-60';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '2' && data.parkerPayType == 'P').amount;
    dataPoint.company = reportData.find((data) => data.agingCategory == '2' && data.parkerPayType == 'C').amount;

    this.dataAmount.push(dataPoint);

    //Get Data  61 - 90 (3)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = '61-90';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '3' && data.parkerPayType == 'P').amount;
    dataPoint.company = reportData.find((data) => data.agingCategory == '3' && data.parkerPayType == 'C').amount;

    this.dataAmount.push(dataPoint);

    //Get Data  > 90 (4)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = 'over 90';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '4' && data.parkerPayType == 'P').amount;
    dataPoint.company = reportData.find((data) => data.agingCategory == '4' && data.parkerPayType == 'C').amount;

    this.dataAmount.push(dataPoint);
  }

  public initReceivablQuantityData(reportData: IReportInvoiceAging[]): void {
    let dataPoint: IReceivableChartData = {} as IReceivableChartData;

    this.data = [];

    //Get Current Data (0)
    dataPoint.segment = 'Current';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '0' && data.parkerPayType == 'P').quantity;
    dataPoint.company = reportData.find((data) => data.agingCategory == '0' && data.parkerPayType == 'C').quantity;

    this.data.push(dataPoint);

    //Get Data  1 - 30 (1)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = '1-30';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '1' && data.parkerPayType == 'P').quantity;
    dataPoint.company = reportData.find((data) => data.agingCategory == '1' && data.parkerPayType == 'C').quantity;

    this.data.push(dataPoint);

    //Get Data  31 - 60 (2)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = '31-60';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '2' && data.parkerPayType == 'P').quantity;
    dataPoint.company = reportData.find((data) => data.agingCategory == '2' && data.parkerPayType == 'C').quantity;

    this.data.push(dataPoint);

    //Get Data  61 - 90 (3)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = '61-90';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '3' && data.parkerPayType == 'P').quantity;
    dataPoint.company = reportData.find((data) => data.agingCategory == '3' && data.parkerPayType == 'C').quantity;

    this.data.push(dataPoint);

    //Get Data  > 90 (4)
    dataPoint = {} as IReceivableChartData;
    dataPoint.segment = 'over 90';
    dataPoint.parker = reportData.find((data) => data.agingCategory == '4' && data.parkerPayType == 'P').quantity;
    dataPoint.company = reportData.find((data) => data.agingCategory == '4' && data.parkerPayType == 'C').quantity;

    this.data.push(dataPoint);
  }

  onSetDataSeriesQuantity(): void {
    this.chartData = this.data;
  }

  onSetDataSeriesAmount(): void {
    this.chartData = this.dataAmount;
  }

  public getFragments(): IgxStackedFragmentSeriesComponent[] {
    const fragment1 = new IgxStackedFragmentSeriesComponent();
    fragment1.valueMemberPath = 'parker';
    fragment1.title = 'Parker';
    fragment1.brush = '#6FCFEB';

    const fragment2 = new IgxStackedFragmentSeriesComponent();
    fragment2.valueMemberPath = 'company';
    fragment2.title = 'Company';
    fragment2.brush = '#002F87';

    const fragments: IgxStackedFragmentSeriesComponent[] = [];
    fragments.push(fragment1);
    fragments.push(fragment2);

    return fragments;
  }

  public onSeriesTypeChanged(e: any) {
    const selectedSeries = e.target.value.toString();
    this.chart.series.clear();
    this.setSeries();
  }

  public setSeries() {
    this.chart.axes.clear();
    this.chart.series.clear();

    const fragments = this.getFragments();

    const stack = new IgxStackedColumnSeriesComponent();
    stack.xAxis = this.catXAxis;
    stack.yAxis = this.numYAxis;
    this.chart.axes.add(this.catXAxis);
    this.chart.axes.add(this.numYAxis);
    for (const frag of fragments) {
      stack.series.add(frag);
    }
    this.chart.series.add(stack);

    // if (seriesType === "Stacked Column") {
    //     const stack = new IgxStackedColumnSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked 100 Column") {
    //     const stack = new IgxStacked100ColumnSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked Area") {
    //     const stack = new IgxStackedAreaSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked 100 Area") {
    //     const stack = new IgxStacked100AreaSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked Line") {
    //     const stack = new IgxStackedLineSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked 100 Line") {
    //     const stack = new IgxStacked100LineSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked Spline") {
    //     const stack = new IgxStackedSplineSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked 100 Spline") {
    //     const stack = new IgxStacked100SplineSeriesComponent();
    //     stack.xAxis = this.catXAxis;
    //     stack.yAxis = this.numYAxis;
    //     this.chart.axes.add(this.catXAxis);
    //     this.chart.axes.add(this.numYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked Bar") {
    //     const stack = new IgxStackedBarSeriesComponent();
    //     stack.xAxis = this.numXAxis;
    //     stack.yAxis = this.catYAxis;
    //     this.chart.axes.add(this.numXAxis);
    //     this.chart.axes.add(this.catYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }
    //     this.chart.series.add(stack);

    // } else if (seriesType === "Stacked 100 Bar") {
    //     const stack = new IgxStacked100BarSeriesComponent();
    //     stack.xAxis = this.numXAxis;
    //     stack.yAxis = this.catYAxis;
    //     this.chart.axes.add(this.numXAxis);
    //     this.chart.axes.add(this.catYAxis);
    //     for (const frag of fragments) {
    //         stack.series.add(frag);
    //     }

    this.chart.series.add(stack);
  }

  // temp(){
  //     this.data = [
  //         { Year: "Current", Parker: 45,  Company: 30},
  //         { Year: "1-30", Parker: 15,  Company: 20},
  //         { Year: "31-60", Parker: 7,  Company: 8},
  //         { Year: "61-90", Parker: 17,  Company: 35},
  //         { Year: "> 90", Parker: 5,  Company: 7},

  //     ];

  //     this.dataAmount = [
  //         { Year: "Current", Parker: 145,  Company: 130},
  //         { Year: "1-30", Parker: 115,  Company: 120},
  //         { Year: "31-60", Parker: 17,  Company: 18},
  //         { Year: "61-90", Parker: 117,  Company: 135},
  //         { Year: "> 90", Parker: 15,  Company: 17},

  //     ];

  // this.chartData = this.data;
  // }
}
